import type {
  CreateCashRebalanceResponse,
  RawCreateCashRebalanceResponse,
} from '@/types/api/cash-rebalance'

/**
 * Normalize the raw cash-rebalance response into the non-null shape consumers
 * expect. accounts-api serializes `rebalanced`/`skipped` from Go slices, and a
 * nil Go slice marshals to JSON `null` (not `[]`) — so an all-skipped run (e.g.
 * the only selected account is skipped for negative cash) arrives with
 * `rebalanced: null`. Coercing to `[]` here keeps `CreateCashRebalanceResponse`
 * honest so callers can read `.length`/`.map` without a null crash.
 */
export function normalizeCashRebalanceResponse(
  response: RawCreateCashRebalanceResponse,
): CreateCashRebalanceResponse {
  return {
    rebalanced: response.rebalanced ?? [],
    skipped: response.skipped ?? [],
    legs_written: response.legs_written ?? 0,
  }
}
